import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';
import StudyLevelModal from "./partials/StudyLevelModal";

import ImportStudyLevelModal from "./partials/ImportStudyLevelModal";

import {
    getStudyLevels as onGetStudyLevels,
    addNewStudyLevel as onAddNewStudyLevel,
    updateStudyLevel as onUpdateStudyLevel,
    deleteStudyLevel as onDeleteStudyLevel,

    getBranches as onGetBranches,
    getSemesters as onGetSemesters,
    resetLastActionSuccess  as OnResetLastActionSuccess,

    getAcademicCycleConfigs as onGetAcademicCycleConfigs


} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const StudyLevel = () => {

    //meta title
    document.title = "Niveaux d'études | CinzanEdu";
    const dispatch = useDispatch();

     const [modal, setModal] = useState(false);
      const [isEdit, setIsEdit] = useState(false);
      const [studyLevel, setStudyLevel] = useState(null);
      const [deleteModal, setDeleteModal] = useState(false);
      const [loadingState, setLoadingState] = useState(true);

      const [modalOpen, setModalOpen] = useState(false);
    


 


    // 🔹 Mise à jour du sélecteur pour inclure AcademicCycleConfigs
    const academicCycleConfigProperties = createSelector(
        (state) => state.academicCycleConfigReducer, 
        (reducer) => ({
            academicCycleConfigs: reducer.academicCycleConfigs,
        })
    );
    const { academicCycleConfigs } = useSelector(academicCycleConfigProperties);





    // Selector study levels
    const StudyLevelProperties = createSelector(
        (state) => state.studyLevelReducer, 
        (studyLevelReducer) => ({
            studyLevels: studyLevelReducer.studyLevels,
            loading: studyLevelReducer.loading,
            lastActionSuccess: studyLevelReducer.lastActionSuccess
        })
    );

    const {studyLevels, loading,  lastActionSuccess} = useSelector(StudyLevelProperties);
    const [isLoading, setLoading] = useState(loading)

    // Selector Branches 
    const BranchProperties = createSelector(
        (state) => state.branchReducer, 
        (branchReducer) => ({
            branches: branchReducer.branches,
            loading: branchReducer.loading
        })
    );

    const {branches} = useSelector(BranchProperties);

    // Selector Semesters
    const SemesterProperties = createSelector(
        (state) => state.semesterReducer, 
        (semesterReducer) => ({
            semesters: semesterReducer.semesters,
            loading: semesterReducer.loading
        })
    );

    const {semesters} = useSelector(SemesterProperties);

    // Chargement initial des données
    useEffect(() => {
        if (!studyLevels.length) dispatch(onGetStudyLevels());
        if (!branches.length) dispatch(onGetBranches());
        if (!semesters.length) dispatch(onGetSemesters());

        if (!academicCycleConfigs.length) dispatch(onGetAcademicCycleConfigs());

        setLoadingState(loading);
    }, [dispatch, studyLevels.length, branches.length,semesters.length, academicCycleConfigs.length,   loading]);


    // Ferme le modal en cas de success
    useEffect(() => {
        console.log("lastActionSuccess:", lastActionSuccess, "modal:", modal);
    if (lastActionSuccess && modal) {
        toggle();
        setStudyLevel(null);
        dispatch(OnResetLastActionSuccess()); // action qui remet à false
    }
    }, [lastActionSuccess, modal, dispatch]);


    

    /*
    useEffect(() => {
        if (studyLevels && !studyLevels.length) {
            dispatch(onGetStudyLevels());
        }
    }, [dispatch, studyLevels]);


    useEffect(() => {
        if (branches && !branches.length) {
            dispatch(onGetBranches());
        }
    }, [dispatch, branches]);

    useEffect(() => {
        if (semesters && !semesters.length) {
            dispatch(onGetSemesters());
        }
    }, [dispatch, semesters]);
    */



     // Toggle modal
    const toggle = () => {
        if (modal) {
            setModal(false);
            setStudyLevel(null);
        } else {
            setModal(true);
        }
    };

    // Toggle modal
    /*const toggle = () => {
        setModal(!modal);
        if (modal) setInternshipStructure(null);
    };
    */

    // Créer nouvelle study level
    const onClickNewStudyLevel = () => {
        setIsEdit(false);
        setStudyLevel(null);
        toggle();
        
    };

     // Edit study level
  const handleStudyLevelClick = (studyLevel) => {
    setStudyLevel(studyLevel);
    setIsEdit(true);
    toggle();
    dispatch(OnResetLastActionSuccess()); // reset pour l’édition
};

  // Delete study level
  const onClickDelete = (studyLevel) => {
    setStudyLevel(studyLevel);
    setDeleteModal(true);
  };

    const handleDeleteStudyLevel = () => {
        if (studyLevel?.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteStudyLevel(studyLevel));
            setDeleteModal(false);
        }
    };

    const handleSuccess = (data) => {
        console.log("Import réussi :", data);
        // ici tu peux recharger la liste des facultés si besoin
    };

    
   

    

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Nom",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Faculté",
                accessorKey: "branch.training_type.faculty.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Filière",
                accessorKey: "branch.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Cycle",
                accessorKey: "academic_cycle_config.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Semestres",
                accessorKey: "semesters",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const semesters = cellProps.row.original.semesters;

                    // Si aucun semestre n'est associé ou si la relation n'est pas chargée
                    if (!semesters || semesters.length === 0) {
                        return <span className="text-muted font-size-12">Aucun</span>;
                    }

                    return (
                        <div className="d-flex flex-wrap gap-1">
                            {semesters.map((semester) => (
                                <Badge 
                                    key={semester.id} 
                                    className="bg-light text-primary border border-primary-subtle"
                                >
                                    {semester.code}
                                </Badge>
                            ))}
                        </div>
                    );
                }
            },
            
        
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleStudyLevelClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteStudyLevel}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Niveaux d'études" breadcrumbItem="Liste des niveaux d'études" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="d-flex gap-2">
                                                    <Button color="success" onClick={() => setModalOpen(true)}>
                                                        Importer un fichier
                                                    </Button>

                                                    <Link to="#!" onClick={onClickNewStudyLevel} className="btn btn-primary me-1">Ajouter un niveau d'étude</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={studyLevels || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    {/* Modal séparé */}
                    <StudyLevelModal
                        modal={modal}
                        toggle={toggle}
                        isEdit={isEdit}
                        studyLevel={studyLevel}
                        branches={branches}
                        semesters={semesters}
                        academicCycleConfigs={academicCycleConfigs || []}
                        onSubmit={(payload) => {
                        if (isEdit) {
                            dispatch(onUpdateStudyLevel(payload));
                        } else {
                            dispatch(onAddNewStudyLevel(payload));
                        }
                        //toggle(); // 🔹 Fermeture automatique après succès
                        }}
                    />
                </div>
            </div>
            <ToastContainer />

            <ImportStudyLevelModal
                isOpen={modalOpen}
                toggle={() => setModalOpen(!modalOpen)}
                onSuccess={handleSuccess}
            />

        </React.Fragment>
    );
}


export default StudyLevel;